export default "__VITE_ASSET__DKabAk8a__"